// in src/users.js
import React from 'react';
import {List, Datagrid, TextField, DateField, Pagination} from 'react-admin';
import {EditButton} from 'react-admin';
import {IHashTag} from '../../consts/Entities';
import {HASH_TAG} from '../../consts/Names';

export const HashTagList = (props: IHashTag) => {
   return (
      <List {...props} title='All hashtags' sort={{field: HASH_TAG.id, order: 'ASC'}} bulkActionButtons={false} exporter={false} perPage={25} pagination={<Pagination rowsPerPageOptions={[25,50,100,200]}/>}>
         <Datagrid>
            <TextField source={HASH_TAG.id} sortable={false}/>
            <TextField source={HASH_TAG.name} sortable={false}/>
            <DateField source={HASH_TAG.created_at} label="Date of creation"/>
            <TextField source={HASH_TAG.number_usage} />
            <EditButton />
         </Datagrid>
      </List>
   );
};
